<script>
  import { mapState, mapGetters } from 'vuex'
  import http from '@/service/http'
  import { GChart } from 'vue-google-charts'
  import moment from 'moment'

  moment.locale('pt-br')

  export default {
    name: 'revisao',
    components: {
      GChart
    },
    data () {
      return {
        orcamento: {},
        revisao: {},
        itens: [],
        pendentes: [],
        aprovados: [],
        regularizados: [],
        reprovados: [],
        canceladas: [],
        recusadas: [],
        ausentes: [],
        tipoRevisao: [],
        vistoriasRealizadas: [],
        vistoriasPendentes: [],
        itensAprovados: [],
        itensReprovados: [],
        itensNaoAplicados: [],
        osApartamentos: [],
        osReprovadasItem: [],
        blocos: [],
        bloco: 'Todos'
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        const {id} = this.$route.params
        this.orcamento.id = id
        const {data} = await http.get(`/orcamentos/relatorios/revisao/${id}`)
        this.revisao = data.revisao
        if (this.revisao.itens.length) {
          this.itens = this.revisao.itens
        }
        this.itensAprovados = data.itensAprovados
        this.itensReprovados = data.itensReprovados
        this.itensNaoAplicados = data.itensNaoAplicados
        this.osApartamentos = data.osApartamentos
        this.osReprovadasItem = data.osReprovadasItem
        this.pendentes = data.pendentes
        this.aprovados = data.aprovados
        this.regularizados = data.regularizados
        this.reprovados = data.reprovados
        this.canceladas = data.canceladas
        this.recusadas = data.recusadas
        this.ausentes = data.ausentes
        this.tipoRevisao = data.tipoRevisao
        this.vistoriasRealizadas = data.vistoriasRealizadas
        this.vistoriasPendentes = data.vistoriasPendentes
        this.blocos = data.blocos
        setTimeout(function () {
          $('.collapsible').collapsible()
          $('.collapsible').collapsible('close', 0)
          $('.collapsible').collapsible('close', 1)
          $('.collapsible').collapsible('close', 2)
          $('.collapsible').collapsible('close', 3)
          $('.collapsible').collapsible('close', 4)
          $('.collapsible').collapsible('close', 5)
          window.Materialize.updateTextFields()
        }, 0)
      },
      formatDate (date) {
        return moment(date).format('DD/MM HH:mm')
      },
      formatDateFrom (date) {
        return moment(date).fromNow()
      },
      getData (data, index) {
        if (typeof data[index] !== 'undefined') {
          return data[index]
        } else {
          return []
        }
      },
      /**
       * @return {number}
       */
      countObj (object) {
        let length = 0
        for (let key in object) {
          if (object.hasOwnProperty(key)) {
            ++length
          }
        }
        return length
      }
    },
    computed: {
      ...mapState(['loading']),
      ...mapGetters(['permissoes']),
      api_url () {
        return process.env.API_URL
      },
      api_root () {
        return process.env.API_ROOT
      },
      id () {
        const {id} = this.$route.params
        return id
      }
    }
  }
</script>

<template>
  <div>
    <div class="content">

      <div class="row">
        <div class="col s12">
          <h5>Relatórios Revisão</h5>

          <div class="row">
            <div class="col s12 m3">
              <label>Blocos, selecione quais blocos devem sair nos PDFs</label>
              <select v-model="bloco">
                <option v-for="row in blocos">{{ row }}</option>
              </select>
            </div>
            <div class="col s12 m4">
              <br clear="all" />
              <a target="_blank" :href="api_url+'/relatorios/'+id+'/pdf?bloco='+bloco">Baixar PDF</a>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col s12" v-for="(tipo, index) in tipoRevisao">
          <div class="row">
            <div class="col s12">
              <h5>{{ tipo }}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col s12 12">
              <table class="bordered highlight responsive-table">
                <thead>
                <tr>
                  <th>Aprovados</th>
                  <th>Reprovados</th>
                  <th>Canceladas</th>
                  <th>Recusadas</th>
                  <th>Clientes Ausentes</th>
                  <th>Pendentes</th>
                  <th>Vistorias Realizadas</th>
                  <th>Vistorias Pendentes</th>
                  <th>Regularizados</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>{{ getData(aprovados, index).length }}</td>
                  <td>{{ getData(reprovados, index).length }}</td>
                  <td>{{ getData(canceladas, index).length }}</td>
                  <td>{{ getData(recusadas, index).length }}</td>
                  <td>{{ getData(ausentes, index).length }}</td>
                  <td>{{ countObj(pendentes) }}</td>
                  <td>{{ countObj(vistoriasRealizadas) }}</td>
                  <td>{{ countObj(vistoriasPendentes) }}</td>
                  <td>{{ countObj(regularizados) }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col s12 m4">
              <h5>Status Geral</h5>
              <GChart
                :settings="{ packages: ['corechart'] }"
                type="PieChart"
                :resizeDebounce="500"
                style="height: 300px;"
                :data="[
                  ['Status', 'OSs'],
                  ['Realizado',  getData(aprovados, index).length + getData(reprovados, index).length + getData(canceladas, index).length + getData(recusadas, index).length + getData(ausentes, index).length],
                  ['Pendente', countObj(pendentes)]
                ]"
              />
            </div>
            <div class="col s12 m4">
              <h5>Status Aprovação</h5>
              <GChart
                :settings="{ packages: ['corechart'] }"
                type="PieChart"
                style="height: 250px;"
                :data="[
                  ['Status', 'OSs'],
                  ['Aprovado',  getData(aprovados, index).length],
                  ['Reprovado', getData(reprovados,index).length],
                  ['Cancelado', getData(canceladas,index).length],
                  ['Recusado', getData(recusadas,index).length],
                  ['Ausente', getData(ausentes,index).length],
                ]"
              />
            </div>
            <div class="col s12 m4">
              <h5>Vistorias</h5>
              <GChart
                :settings="{ packages: ['corechart'] }"
                type="PieChart"
                :resizeDebounce="500"
                style="height: 250px;"
                :data="[
                  ['Status', 'OSs'],
                  ['Realizado',  countObj(vistoriasRealizadas)],
                  ['Pendente', countObj(vistoriasPendentes)]
                ]"
              />
            </div>
          </div>

          <hr>
          <br clear="all" />
          <br clear="all" />

          <div class="row">
            <div class="col s12 12">
              <table class="bordered highlight responsive-table">
                <thead>
                <tr>
                  <th>Itens da Revisão</th>
                  <th>Aprovados</th>
                  <th>Reprovados</th>
                  <th>Não Aplicável</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in itens">
                  <td>{{ item.inspecao }}</td>
                  <td>{{ itensAprovados[item.id] }}</td>
                  <td>{{ itensReprovados[item.id] }}</td>
                  <td>{{ itensNaoAplicados[item.id] }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <hr>
          <br clear="all" />
          <br clear="all" />

          <div class="row">
            <div class="col s12">
              <table class="bordered highlight responsive-table">
                <thead>
                <tr>
                  <th>Reprovações por Item</th>
                  <th>Apartamentos</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in itens">
                  <td>{{ item.inspecao }}</td>
                  <td>
                    <div class="row">
                      <div class="col s12 m4" v-for="(row, index) in osReprovadasItem[item.id]">
                        {{ osApartamentos[row] }}
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row">

            <div class="col s12 m10 offset-m1">

              <div class="row">
                <div class="col s12 m4">
                  <label>Blocos, selecione quais blocos devem sair nos PDFs</label>
                  <select v-model="bloco">
                    <option v-for="row in blocos">{{ row }}</option>
                  </select>
                </div>
              </div>

              <p>
                <a :href="`${api_url}/revisoes/${orcamento.id}/todas/pdf?bloco=${bloco}`" class="material-icons blue-text" target="_blank" title="PDF REVISÃO"><i class="material-icons">file_download</i></a> Imprimir Revisões<span v-show="bloco !== 'Todos'">, {{ bloco }}</span> |
                <a :href="`${api_root}/revisao/${orcamento.id}/relatorio?status=todas`" target="_blank" title="PDF REVISÃO"> Listagem para o Cliente</a>
              </p>

              <ul class="collapsible popout" data-collapsible="accordion">
                <li>
                  <div class="collapsible-header green-text text-darken-3">
                    Regularizados
                  </div>
                  <div class="collapsible-body">
                    <p>
                      <a :href="`${api_root}/revisao/${orcamento.id}/relatorio?status=regularizados`" target="_blank" title="Regularizados"> Listagem para o Cliente</span></a>
                    </p>
                    <table class="responsive-table bordered highlight">
                      <thead>
                      <tr>
                        <th>#</th>
                        <th>Apartamento</th>
                        <th>Status</th>
                        <th class="right-align">Ações</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="os in regularizados">
                        <td>
                          <router-link :to="{ name: 'os.form', params: { id: os.id } }" v-if="permissoes.indexOf('os.editar') > -1">{{ os.id }}</router-link>
                          <span v-else>{{ os.id }}</span>
                        </td>
                        <td>{{ os.apartamento ? `${os.apartamento}` : ''}}</td>
                        <td>{{ os.status ? `${os.status.status}` : ''}}</td>
                        <td class="right-align">
                          <a :href="`${api_url}/os/${os.id}/pdf`" class="material-icons green-text" target="_blank" title="PDF OS"><i class="material-icons">file_download</i></a>
                          <router-link :to="{ name: 'os.form', params: { id: os.id } }" v-show="permissoes.indexOf('os.editar') > -1"><i class="material-icons blue-text">edit</i></router-link>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
                <li>
                  <div class="collapsible-header green-text text-darken-3">
                    Pendentes
                  </div>
                  <div class="collapsible-body">
                    <p>
                      <a :href="`${api_url}/revisoes/${orcamento.id}/pendentes/pdf?bloco=${bloco}`" class="material-icons blue-text" target="_blank" title="PDF REVISÃO"><i class="material-icons">file_download</i></a> Imprimir Revisões<span v-show="bloco !== 'Todos'">, {{ bloco }}</span> |
                      <a :href="`${api_root}/revisao/${orcamento.id}/relatorio?status=pendente`" target="_blank" title="PDF REVISÃO"> Listagem para o Cliente</a>
                    </p>
                    <table class="responsive-table bordered highlight">
                      <thead>
                      <tr>
                        <th>#</th>
                        <th>Apartamento</th>
                        <th class="right-align">Ações</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="os in pendentes">
                        <td>
                          <router-link :to="{ name: 'os.form', params: { id: os.id } }" v-if="permissoes.indexOf('os.editar') > -1">{{ os.id }}</router-link>
                          <span v-else>{{ os.id }}</span>
                        </td>
                        <td>{{ os.apartamento ? `${os.apartamento}` : ''}}</td>
                        <td class="right-align">
                          <a :href="`${api_url}/revisao/${os.id}/pdf`" class="material-icons blue-text" target="_blank" title="PDF REVISÃO"><i class="material-icons">file_download</i></a>
                          <a :href="`${api_url}/os/${os.id}/pdf`" class="material-icons green-text" target="_blank" title="PDF OS"><i class="material-icons">file_download</i></a>
                          <router-link :to="{ name: 'os.form', params: { id: os.id } }" v-show="permissoes.indexOf('os.editar') > -1"><i class="material-icons blue-text">edit</i></router-link>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
                <li>
                  <div class="collapsible-header green-text text-darken-3">
                    Reprovadas
                  </div>
                  <div class="collapsible-body">
                    <p>
                      <a :href="`${api_url}/revisoes/${orcamento.id}/reprovadas/pdf?bloco=${bloco}`" class="material-icons blue-text" target="_blank" title="PDF REVISÃO"><i class="material-icons">file_download</i></a> Imprimir Revisões<span v-show="bloco !== 'Todos'">, {{ bloco }}</span> |
                      <a :href="`${api_root}/revisao/${orcamento.id}/relatorio?status=reprovadas`" target="_blank" title="PDF REVISÃO"> Listagem para o Cliente</a>
                    </p>
                    <table class="responsive-table bordered highlight">
                      <thead>
                      <tr>
                        <th>#</th>
                        <th>Apartamento</th>
                        <th class="right-align">Ações</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="os in getData(reprovados, index)">
                        <td>
                          <router-link :to="{ name: 'os.form', params: { id: os.id } }" v-if="permissoes.indexOf('os.editar') > -1">{{ os.id }}</router-link>
                          <span v-else>{{ os.id }}</span>
                        </td>
                        <td>{{ os.apartamento ? `${os.apartamento}` : ''}}</td>
                        <td class="right-align">
                          <a :href="`${api_url}/revisao/${os.id}/pdf`" class="material-icons blue-text" target="_blank" title="PDF REVISÃO"><i class="material-icons">file_download</i></a>
                          <a :href="`${api_url}/os/${os.id}/pdf`" class="material-icons green-text" target="_blank" title="PDF OS"><i class="material-icons">file_download</i></a>
                          <router-link :to="{ name: 'os.form', params: { id: os.id } }" v-show="permissoes.indexOf('os.editar') > -1"><i class="material-icons blue-text">edit</i></router-link>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
                <li>
                  <div class="collapsible-header green-text text-darken-3">
                    Revisões Canceladas
                  </div>
                  <div class="collapsible-body">
                    <p>
                      <a :href="`${api_url}/revisoes/${orcamento.id}/canceladas/pdf?bloco=${bloco}`" class="material-icons blue-text" target="_blank" title="PDF REVISÃO"><i class="material-icons">file_download</i></a> Imprimir Revisões<span v-show="bloco !== 'Todos'">, {{ bloco }}</span> |
                      <a :href="`${api_root}/revisao/${orcamento.id}/relatorio?status=canceladas`" target="_blank" title="PDF REVISÃO"> Listagem para o Cliente</a>
                    </p>
                    <table class="responsive-table bordered highlight">
                      <thead>
                      <tr>
                        <th>#</th>
                        <th>Apartamento</th>
                        <th class="right-align">Ações</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="os in getData(canceladas, index)">
                        <td>
                          <router-link :to="{ name: 'os.form', params: { id: os.id } }" v-if="permissoes.indexOf('os.editar') > -1">{{ os.id }}</router-link>
                          <span v-else>{{ os.id }}</span>
                        </td>
                        <td>{{ os.apartamento ? `${os.apartamento}` : ''}}</td>
                        <td class="right-align">
                          <a :href="`${api_url}/revisao/${os.id}/pdf`" class="material-icons blue-text" target="_blank" title="PDF REVISÃO"><i class="material-icons">file_download</i></a>
                          <a :href="`${api_url}/os/${os.id}/pdf`" class="material-icons green-text" target="_blank" title="PDF OS"><i class="material-icons">file_download</i></a>
                          <router-link :to="{ name: 'os.form', params: { id: os.id } }" v-show="permissoes.indexOf('os.editar') > -1"><i class="material-icons blue-text">edit</i></router-link>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
                <li>
                  <div class="collapsible-header green-text text-darken-3">
                    Recusadas
                  </div>
                  <div class="collapsible-body">
                    <p>
                      <a :href="`${api_url}/revisoes/${orcamento.id}/recusadas/pdf?bloco=${bloco}`" class="material-icons blue-text" target="_blank" title="PDF REVISÃO"><i class="material-icons">file_download</i></a> Imprimir Revisões<span v-show="bloco !== 'Todos'">, {{ bloco }}</span> |
                      <a :href="`${api_root}/revisao/${orcamento.id}/relatorio?status=recusadas`" target="_blank" title="PDF REVISÃO"> Listagem para o Cliente</a>
                    </p>
                    <table class="responsive-table bordered highlight">
                      <thead>
                      <tr>
                        <th>#</th>
                        <th>Apartamento</th>
                        <th class="right-align">Ações</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="os in getData(recusadas, index)">
                        <td>
                          <router-link :to="{ name: 'os.form', params: { id: os.id } }" v-if="permissoes.indexOf('os.editar') > -1">{{ os.id }}</router-link>
                          <span v-else>{{ os.id }}</span>
                        </td>
                        <td>{{ os.apartamento ? `${os.apartamento}` : ''}}</td>
                        <td class="right-align">
                          <a :href="`${api_url}/revisao/${os.id}/pdf`" class="material-icons blue-text" target="_blank" title="PDF REVISÃO"><i class="material-icons">file_download</i></a>
                          <a :href="`${api_url}/os/${os.id}/pdf`" class="material-icons green-text" target="_blank" title="PDF OS"><i class="material-icons">file_download</i></a>
                          <router-link :to="{ name: 'os.form', params: { id: os.id } }" v-show="permissoes.indexOf('os.editar') > -1"><i class="material-icons blue-text">edit</i></router-link>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
                <li>
                  <div class="collapsible-header green-text text-darken-3">
                    Cliente Ausente
                  </div>
                  <div class="collapsible-body">
                    <p>
                      <a :href="`${api_url}/revisoes/${orcamento.id}/ausentes/pdf?bloco=${bloco}`" class="material-icons blue-text" target="_blank" title="PDF REVISÃO"><i class="material-icons">file_download</i></a> Imprimir Revisões<span v-show="bloco !== 'Todos'">, {{ bloco }}</span> |
                      <a :href="`${api_root}/revisao/${orcamento.id}/relatorio?status=ausentes`" target="_blank" title="PDF REVISÃO"> Listagem para o Cliente</a>
                    </p>
                    <table class="responsive-table bordered highlight">
                      <thead>
                      <tr>
                        <th>#</th>
                        <th>Apartamento</th>
                        <th class="right-align">Ações</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="os in getData(ausentes, index)">
                        <td>
                          <router-link :to="{ name: 'os.form', params: { id: os.id } }" v-if="permissoes.indexOf('os.editar') > -1">{{ os.id }}</router-link>
                          <span v-else>{{ os.id }}</span>
                        </td>
                        <td>{{ os.apartamento ? `${os.apartamento}` : ''}}</td>
                        <td class="right-align">
                          <a :href="`${api_url}/revisao/${os.id}/pdf`" class="material-icons blue-text" target="_blank" title="PDF REVISÃO"><i class="material-icons">file_download</i></a>
                          <a :href="`${api_url}/os/${os.id}/pdf`" class="material-icons green-text" target="_blank" title="PDF OS"><i class="material-icons">file_download</i></a>
                          <router-link :to="{ name: 'os.form', params: { id: os.id } }" v-show="permissoes.indexOf('os.editar') > -1"><i class="material-icons blue-text">edit</i></router-link>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
                <li>
                  <div class="collapsible-header green-text text-darken-3">
                    Aprovadas
                  </div>
                  <div class="collapsible-body">
                    <p>
                      <a :href="`${api_url}/revisoes/${orcamento.id}/aprovadas/pdf?bloco=${bloco}`" class="material-icons blue-text" target="_blank" title="PDF REVISÃO"><i class="material-icons">file_download</i></a> Imprimir Revisões<span v-show="bloco !== 'Todos'">, {{ bloco }}</span> |
                      <a :href="`${api_root}/revisao/${orcamento.id}/relatorio?status=aprovadas`" target="_blank" title="PDF REVISÃO"> Listagem para o Cliente</a>
                    </p>
                    <table class="responsive-table bordered highlight">
                      <thead>
                      <tr>
                        <th>#</th>
                        <th>Apartamento</th>
                        <th class="right-align">Ações</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="os in getData(aprovados, index)">
                        <td>
                          <router-link :to="{ name: 'os.form', params: { id: os.id } }" v-if="permissoes.indexOf('os.editar') > -1">{{ os.id }}</router-link>
                          <span v-else>{{ os.id }}</span>
                        </td>
                        <td>{{ os.apartamento ? `${os.apartamento}` : ''}}</td>
                        <td class="right-align">
                          <a :href="`${api_url}/revisao/${os.id}/pdf`" class="material-icons blue-text" target="_blank" title="PDF REVISÃO"><i class="material-icons">file_download</i></a>
                          <a :href="`${api_url}/os/${os.id}/pdf`" class="material-icons green-text" target="_blank" title="PDF OS"><i class="material-icons">file_download</i></a>
                          <router-link :to="{ name: 'os.form', params: { id: os.id } }" v-show="permissoes.indexOf('os.editar') > -1"><i class="material-icons blue-text">edit</i></router-link>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
              </ul>

            </div>

          </div>

        </div>
      </div>

    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/features/relatorios/revisao.vue